import { useEffect, useState } from "react"
import { Integration, RateTableConfig } from "../../../../../types"
import { useIntegrationSettingsForm } from "../../../../hooks"
import { useFetchRateTableConfigsQuery } from "../../../../../redux/queries"
import Form from "../../../form"

interface RateTableSelectorProps {
  integration: Integration
}

const RateTableSelector = ({ integration }: RateTableSelectorProps) => {
  const { app_settings, saveAppSetting } =
    useIntegrationSettingsForm(integration)

  const [selected, setSelectedRateTable] = useState<RateTableConfig | null>(
    null
  )
  const [selectedID, setSelectedRateTableID] = useState<number | string>(
    app_settings?.rate_table_config ?? ""
  )

  const { data: rateTables = [], isLoading } = useFetchRateTableConfigsQuery(
    { brand_id: integration?.brand_id },
    {
      skip: !integration?.brand_id
    }
  )

  const setSelected = (rateTableID: string) => {
    if (rateTableID !== selectedID) {
      setSelectedRateTableID(rateTableID)
      saveAppSetting({ rate_table_config: rateTableID })
    }
  }

  useEffect(() => {
    const selectedRateTable = rateTables?.find(
      (rt: RateTableConfig) => rt.id === selectedID + ""
    )
    setSelectedRateTable(selectedRateTable ?? null)
  }, [selectedID, rateTables])

  return (
    <div className="flex items-center pl-9">
      <Form.InlineSelect
        isLoading={isLoading}
        data={rateTables}
        setSelected={setSelected}
        selected={selected}
        label="Choose a rate table"
      />
    </div>
  )
}

export default RateTableSelector
